import { createSlice } from "@reduxjs/toolkit";
import { api } from "utils";

const initialState = {
  list: [],
  counts: {
    totalMemberCount: 0,
    approvedMemberCount: 0,
    canceledMemberCount: 0,
  },
  pagination: {
    page: 1,
    pageSize: 10,
    pageState: true,
  },
  fromTop: 0,
  loading: false,
  error: null,
};

const link = createSlice({
  name: "link",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },

    setPagination: (state, action) => {
      state.pagination = Object.assign(state.pagination, action.payload);
    },

    resetPagination: (state) => {
      state.pagination = initialState.pagination;
    },

    setList: (state, action) => {
      state.list = action.payload;
    },

    setCounts: (state, action) => {
      state.counts = action.payload;
    },

    setFromTop: (state, action) => {
      state.fromTop = action.payload;
    },

    fetchFail: (state, action) => {
      state.error = action.payload;
    },

    resetLinkRequests: () => initialState,
  },
});

export const {
  setLoading,
  setPagination,
  resetPagination,
  setList,
  setCounts,
  setFromTop,
  fetchFail,
  resetLinkRequests,
} = link.actions;

export const fetchRequests =
  (isUpdate, filter) => async (dispatch, getState) => {
    try {
      const tabs = {
        0: null,
        1: "A",
        2: "D",
      };
      const { seqPartner } = getState().partner;
      const { list, pagination } = getState().link;

      if (isUpdate) {
        dispatch(setPagination({ pageState: undefined }));
        dispatch(setLoading(true));

        await api
          .post("/member-app/interlock/members", {
            seqPartner: seqPartner,
            searchWord: filter.searchTerm,
            startDt: filter.startDt,
            endDt: filter.endDt,
            seqPartnerBranch: filter.seqPartnerBranch,
            interlockType: tabs[filter.activeTab],
            criteria: {
              page: pagination.page,
              pageSize: pagination.pageSize,
            },
          })
          .then(({ data }) => {
            const counts = {
              totalMemberCount: data.totalMemberCount,
              approvedMemberCount: data.approvedMemberCount,
              canceledMemberCount: data.canceledMemberCount,
            };
            dispatch(setCounts(counts));

            const newList =
              pagination.page > 1
                ? list.concat(data.interlockMembers.results)
                : data.interlockMembers.results;
            dispatch(setList(newList));
            dispatch(
              setPagination({
                page: data.interlockMembers.last
                  ? pagination.page
                  : pagination.page + 1,
                pageState: !data.interlockMembers.last,
              })
            );
            dispatch(setLoading(false));
          })
          .catch((error) => {
            dispatch(fetchFail(error.message));
            dispatch(setLoading(false));
          });
      } else {
        dispatch(setList([]));
        dispatch(resetPagination());
      }
    } catch (error) {
      dispatch(fetchFail(error.message));
      dispatch(setLoading(false));
      console.error(error);
    }
  };

export const handleRespond = (props) => async (dispatch, getState) => {
  try {
    const { seqPartner } = getState().partner;

    await api
      .patch("/member-app/interlock", {
        intlReqDtlId: props.intlReqDtlId,
        interlockType: props.interlockType,
        seqMember: props.seqMember,
        seqPartner,
        seqPartnerBranch: props.filter.seqPartnerBranch,
      })
      .then(({ data }) => {
        dispatch(resetPagination())
        dispatch(setList([]));
        dispatch(fetchRequests(true, props.filter));
      });
  } catch (error) {
    console.error();
  }
};

export default link.reducer;
